// extracted by mini-css-extract-plugin
export default {"load":"Loader_load__NtETK","move":"Loader_move__qa2vm"};